import type { ReactNode } from 'react';
import { DialogProvider } from './Dialogs';
import { ToastProvider } from './Toasts';
import { TooltipLayer } from './Tooltips';
import { UnsavedChangesProvider } from './UnsavedChanges';
import { VersionGate } from './VersionGate';

/** Wires all app-level UI services: toasts, dialogs, unsaved-changes guard, tooltips and the version gate. */
export function UIProvider({ children, build }: { children: ReactNode; build: string }) {
  return (
    <ToastProvider>
      <DialogProvider>
        <UnsavedChangesProvider>
          {children}
          <TooltipLayer />
          <VersionGate currentBuild={build} />
        </UnsavedChangesProvider>
      </DialogProvider>
    </ToastProvider>
  );
}
